import {GuidePostSerializer} from "@oldDashboard/legacyModels/serializers/guidePostSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandTopPerformingNetwork {
    async run(affiliateId: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String) {  
        const path = `top-performer/?affiliate_id=${affiliateId}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&start_date=&${startDate}&end_date=${endDate}`
        try {
            const response = await legacyReportingGet(path);
            return response
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        const serializer = new GuidePostSerializer();
        return serializer.deserializeList(data);
    }
}

